import a, { createContext as r, useState as u, useEffect as m, useContext as c } from "react";
const l = r({
  name: "",
  email: "",
  avatarImgSrc: null
}), D = () => c(l), f = (e) => {
  const [t, n] = u();
  return m(() => {
    async function s() {
      if (e.authClient) {
        const i = await e.authClient.getIdentity();
        n({
          name: i.name,
          email: i.email
        });
      } else
        n(e.userDetails);
    }
    s();
  }, [e.authClient, e.userDetails]), t ? /* @__PURE__ */ a.createElement(
    l.Provider,
    {
      value: {
        name: t.name,
        email: t.email,
        avatarImgSrc: t.avatarImgSrc
      }
    },
    e.children
  ) : /* @__PURE__ */ a.createElement(a.Fragment, null);
};
export {
  f as U,
  D as u
};
